import React from "react";
import SEO from "../components/SEO";
import { PAGES } from "../seo/pages.config";
import DevSprintArea from "../components/DevSprintArea";
import Breadcrumb from "../components/Breadcrumb";
import FooterFour from "../components/FooterFour";
import NavBarThree from "../components/NavbarThree";

const DevSprint = () => {
  return (
    <>
      <SEO canonical="/accelerator/dev-sprint" {...PAGES["/accelerator/dev-sprint"]} />
      {/* Navigation Bar */}
      <NavBarThree />

      {/* Navigation Bar */}
      <Breadcrumb title={"Evolvelab Dev Sprint"} />

      {/* Service Details Area */}
      <DevSprintArea />

      {/* Footer One */}
      <FooterFour />
    </>
  );
};

export default DevSprint;
